// @https://codeorum.com/tutorials/simple-accordion-collapsible-element-with-vanilla-js-and-simple-animation-effect
// @https://codepen.io/codeorum/pen/JjGzMRQ

function initAcc(elem, option) {
	document.addEventListener("click", function (e) {
		if (!e.target.matches(elem)) return;
		else {
			if (!e.target.parentElement.classList.contains("active")) {
				if (option == true) {
					var elementList = document.querySelectorAll(
						elem + " .woocommerce-widget-layered-nav"
					);
					Array.prototype.forEach.call(elementList, function (e) {
						e.classList.remove("active");
					});
				}
				e.target.parentElement.classList.add("active");
			} else {
				e.target.parentElement.classList.remove("active");
			}
		}
	});
}

initAcc(".woocommerce .sidebar-inner .woocommerce-widget-layered-nav h2, .woocommerce .sidebar-inner .widget_price_filter h2", false);

/**WooCommerce js event
 * https://wordpress.stackexchange.com/questions/342148/list-of-js-events-in-the-woocommerce-frontend
 */
jQuery("body").on("init_checkout", function () {
	console.log("init_checkout triggered");
	// now.do.whatever();
});
